import { TextField } from "@mui/material";
import {
  BackgroundIcon,
  LoginButton,
  LoginForm,
  LoginLeft,
  LoginNote,
  LoginRight,
  LoginTitle,
  LoginWrapper,
  LogoBox,
  RightLogo,
} from "../../style/admin/AdminLogin_Style";
import { GoogleButton } from "../../App_Style";
import { useEffect, useRef, useState } from "react";
import { envConfig } from "../../config/env.config";
import { IEmailLoginRequest, IGoogleLoginRequest } from "../../models/auth";
import AuthService from "../../services/api/auth.service";
import { parseJwt } from "../../common/helper";
import { useStore } from "../../zustand";
import { ITokenPayload } from "../../models/user";
import { useNavigate } from "react-router-dom";
import { toast } from "../../utils/notify";
import ToastContainer from "../../notification/NotificationBell";

const AdminLoginPage = () => {
  const googleInited = useRef(false);
  const [user, setUser] = useState<ITokenPayload | null>();
  const setData = useStore((s) => s.setData);
  const navigate = useNavigate();
  const [email, setEmail] = useState<string>("");
  const [passWord, setPassWord] = useState<string>("");

  useEffect(() => {
    if (googleInited.current) return;

    const interval = setInterval(() => {
      if (window.google && document.getElementById("googleSignInDiv")) {
        window.google.accounts.id.initialize({
          client_id: envConfig.CLIENT_ID_GOOGLE,
          callback: handleGoogleLogin,
        });

        window.google.accounts.id.renderButton(
          document.getElementById("googleSignInDiv"),
          { theme: "outline", size: "medium" },
        );

        googleInited.current = true;
        clearInterval(interval);
      }
    }, 100);

    return () => clearInterval(interval);
  }, []);

  const handleGoogleLogin = async (res: any) => {
    const rq: IGoogleLoginRequest = {
      credential: res.credential,
    };

    const resLogin = await AuthService.adminLoginWithEmail(rq);
    if (resLogin.success) {
      localStorage.setItem("token", resLogin.data.token);
      setData("loginSuccess");
      const decoded = parseJwt(res.credential);

      setUser({
        fullName: decoded.name,
        email: decoded.email,
        avatar: decoded.picture,
        userId: "",
        createdAt: "",
      });

      navigate("../admin");
    } else {
      toast(resLogin.message, "error");
    }
  };

  const handleEmailLogin = async () => {
    const rq: IEmailLoginRequest = {
      email: email,
      password: passWord,
    };
    const resLogin = await AuthService.loginWithMail(rq);
    if (resLogin.success) {
      localStorage.setItem("token", resLogin.data.token);
      setData("loginSuccess");

      setUser({
        fullName: resLogin.data.user.fullName,
        email: resLogin.data.user.email,
        avatar: resLogin.data.user.avatar,
        userId: resLogin.data.user.id,
        createdAt: "",
      });

      navigate("../admin");
    } else {
      toast(resLogin.message, "error");
    }
  };
  return (
    <LoginWrapper>
      {/* LEFT */}
      <LoginLeft>
        <LogoBox>
          <img src="/logo/Untitled-1.svg" alt="logo" height={36} />
        </LogoBox>

        <LoginTitle>Đăng nhập</LoginTitle>

        <LoginForm>
          <TextField
            onChange={(e) => {
              setEmail(e.target.value);
            }}
            fullWidth
            label="Email"
            variant="outlined"
            size="medium"
          />

          <TextField
            onChange={(e) => {
              setPassWord(e.target.value);
            }}
            fullWidth
            label="Mật khẩu"
            type="password"
            variant="outlined"
            size="medium"
          />

          <LoginButton onClick={() => handleEmailLogin()} variant="contained">
            Đăng nhập
          </LoginButton>
        </LoginForm>

        <br />

        <GoogleButton id="googleSignInDiv" />

        <br />

        <LoginNote>
          Nếu đăng nhập lần đầu, vui lòng truy cập mail để nhận mật khẩu.
          <br />
          Quên mật khẩu vui lòng liên hệ admin để được cấp lại mật khẩu.
        </LoginNote>
      </LoginLeft>

      {/* RIGHT */}
      <LoginRight>
        <BackgroundIcon />
        <RightLogo>
          <img src="/logo/Untitled-1.svg" alt="logo" width={80} />
        </RightLogo>
      </LoginRight>
      <ToastContainer />
    </LoginWrapper>
  );
};

export default AdminLoginPage;
